import React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import { ClientPasswordEditor } from 'containers/ClientPasswordEditor';
import { RestorePasswordPage } from 'containers/RestorePasswordPage';
import { routes } from 'utils/routes';
import { DemoStackManager } from 'containers/DemoStackManager/DemoStackManager';
import { ProdStackManager } from 'containers/ProdStackManager/ProdStackManager';
import { Oauth2Page } from 'containers/Ouath2Page';
import { PartnerRegistrationManager } from 'containers/PartnerRegistrationManager/PartnerRegistrationManager';
import { PromocodeRegistrationManager } from 'containers/PromocodeRegistrationManager/PromocodeRegistrationManager';

export const AppRoutingShared = () => {
  return (
    <Switch>
      <Route exact path={routes.registrationDemoPattern()}>
        <DemoStackManager />
      </Route>
      <Route exact path={routes.registrationProdPattern()}>
        <ProdStackManager />
      </Route>
      <Route exact path={routes.registrationPartnerPattern()}>
        <PartnerRegistrationManager />
      </Route>

      <Route exact path={routes.registrationPattern()}>
        <Redirect to={routes.registrationDemo()} />
      </Route>

      <Route exact path={routes.restorePasswordPattern()}>
        <RestorePasswordPage />
      </Route>
      <Route exact path={routes.restorePasswordValidTokenPattern()}>
        <ClientPasswordEditor />
      </Route>
      <Route exact path={routes.restorePasswordExpiredPattern()}>
        <Redirect to="/" />
      </Route>

      <Route path={routes.authorizationWithDemoPattern()}>
        <Redirect to={routes.registrationDemo()} />
      </Route>
      <Route path={routes.authorizationWithProdPattern()}>
        <Redirect to={routes.registrationProd()} />
      </Route>

      <Route
        path={routes.orderPattern()}
        render={({
          match: {
            params: { orderId },
          },
        }) => {
          return <Redirect to={routes.registrationProd(orderId)} />;
        }}
      />

      <Route path={routes.promocodePattern()}>
        <PromocodeRegistrationManager />
      </Route>

      <Route path={routes.oauth2Pattern()}>
        <Oauth2Page />
      </Route>

      <Route path="/">
        <Redirect to="/" />
      </Route>
    </Switch>
  );
};
